import React, { Component } from "react";
import HeaderLogo from "../headerLogo/HeaderLogo";
import Nav from "../nav/Nav";
import ProfileBtn from "../profileBtn/ProfileBtn";

import "./header.css";

export default class Header extends Component {
  render() {
    // console.log(this.props);
    return (
      <header className="header">
        <HeaderLogo />
        <Nav />
        <ProfileBtn />
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/header/Header.js